// extracted by mini-css-extract-plugin
module.exports = {"base":"ExternalVendors_base__30bom","cell":"ExternalVendors_cell__3LSJr","dropDownSelection":"ExternalVendors_dropDownSelection__3zPjn"};